import {
  AccessControl,
  getTranslatedText,
  withErrorBoundary
} from '@nile/components';
import ArticleSearchSheet from '@nile/rmm/src/modules/knowledge-base/components/ArticleSearchSheet';
import { SVGIcon } from '@superops/super-icons';
import { Button, Sheet, Tippy } from '@superops/ui-design-system';
import React, { useCallback, useState } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useIntl } from 'react-intl';

const TicketKnowledgeBase = ({ ticketId, onArticleCopy = () => {} }) => {
  const intl = useIntl();

  const [showKb, setShowKb] = useState(false);
  const toggleKBSheetActive = useCallback(
    () => setShowKb((prevState) => !prevState),
    []
  );

  return (
    <AccessControl
      roleToCheck="knowledgeBase.view"
      render={
        <div>
          <Tippy
            title={getTranslatedText(intl, 'common.knowledge.base')}
            inertia
            trigger="mouseenter"
            animation="shift"
            animateFill={false}
            className="tooltip"
            position="bottom"
            arrow
          >
            <Button
              id="actionKbTemplates"
              plain
              onClick={toggleKBSheetActive}
              icon={<SVGIcon name="Notes" />}
            />
          </Tippy>

          <Sheet open={showKb} onClose={toggleKBSheetActive}>
            <ArticleSearchSheet
              toggleKBSheetActive={toggleKBSheetActive}
              ticketId={ticketId}
              insertLink={onArticleCopy}
            />
          </Sheet>
        </div>
      }
    />
  );
};

export default withErrorBoundary(TicketKnowledgeBase);
